// import { Menu as MenuIcon, School } from '@mui/icons-material';
import { Menu as MenuIcon } from '@material-ui/icons';
import { AppBar, Box, Button, Container, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText, Toolbar } from '@mui/material';
import { useState } from 'react';
import logo from '../assets/img/logol.png';

const navigation = [
    { name: "Home", href: "#hero" },
    // { name: "Values", href: "#values" },
    { name: "Services", href: "#services" },
    { name: "About", href: "#about" },
    { name: "Contact Us", href: "#footer" },
    { name: "Learner Login", href: "https://www.learner.learningfitbit.com" }
];

const Header = () => {
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const onHandleSignIn = () => {
        // navigation('/auth/signIn')
        window.location.href = '/auth/signIn'
    }

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <List>
                {navigation.map((item) => (
                    <ListItem key={item.name} disablePadding>
                        <ListItemButton
                            component="a"
                            href={item.href}
                            sx={{ textAlign: 'center', textTransform: 'none' }}
                        >
                            <ListItemText primary={item.name} />
                        </ListItemButton>
                    </ListItem>
                ))}
                <ListItem disablePadding sx={{ mt: 2 }}>
                    <ListItemButton
                        onClick={onHandleSignIn}
                        sx={{
                            justifyContent: 'center',
                            textAlign: 'center',
                            background: '#f59f0a',
                            mx: 2,
                            borderRadius: 2,
                            color: '#fff',
                            '&:hover': { background: '#e08e00' }
                        }}
                    >
                        <ListItemText primary="Sign In" />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );

    return (
        <>
            <AppBar
                position="fixed"
                sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)',
                }}
            >
                <Container maxWidth="lg">
                    <Toolbar
                        disableGutters
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        {/* Left — Logo */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: 40,
                                    height: 40,
                                    borderRadius: 2,
                                    background: "linear-gradient(173deg, #6f41e37d 0%, #e7616930 100%)", //"linear-gradient(135deg, #7C3AED 0%, #10B981 100%)",
                                    overflow: "hidden",
                                }}
                            >
                                {/* <School sx={{ color: "white", fontSize: 24 }} /> */}
                                <img
                                    src={logo}
                                    alt="brand logo"
                                    style={{
                                        width: "70%",
                                        height: "70%",
                                        objectFit: "contain",
                                    }}
                                />
                            </Box>
                            <Box sx={{ fontSize: "1.25rem", fontWeight: 700 }}>
                                <Box component="span" sx={{ color: '#3c83f6' }}>
                                    learning
                                </Box>
                                <Box component="span" sx={{ color: '#f59f0a' }}>
                                    Fitbit
                                </Box>
                            </Box>
                        </Box>

                        {/* Center — Navigation */}
                        <Box
                            sx={{
                                flexGrow: 1,
                                display: { xs: "none", md: "flex" },
                                justifyContent: "center",
                                gap: 2,
                            }}
                        >
                            {navigation.map((item) => (
                                <Button
                                    key={item.name}
                                    href={item.href}
                                    sx={{
                                        color: "text.primary",
                                        textTransform: "none",
                                        "&:hover": {
                                            color: "primary.main",
                                        },
                                    }}
                                >
                                    {item.name}
                                </Button>
                            ))}
                        </Box>

                        {/* Right — Sign In Button */}
                        <Box sx={{ display: { xs: "none", md: "flex" } }}>
                            <Button
                                variant="contained"
                                sx={{
                                    textTransform: "none",
                                    borderRadius: "8px",
                                    px: 3,
                                    background: '#f59f0a'
                                }}
                                onClick={onHandleSignIn}
                            >
                                Sign In
                            </Button>
                        </Box>

                        {/* Mobile menu icon */}
                        <IconButton
                            color="primary"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ display: { md: "none" }, marginLeft: "auto" }}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Toolbar>

                </Container>
            </AppBar>

            {/* Mobile Drawer */}
            <Drawer
                variant="temporary"
                anchor="right"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true,
                }}
                sx={{
                    display: { xs: 'block', md: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
                }}
            >
                {drawer}
            </Drawer>
            <Toolbar />
        </>
    );
};

export default Header;
